/**
 * Initial assessment page with intro text and start button.
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';
import ButtonNext from './ButtonNext';

function Intro({ actionButton, disabled, introText, nextStep, title }) {
  return (
    <div
      className={classnames({
        intro: true,
      })}
    >
      <h1>{title}</h1>
      <div dangerouslySetInnerHTML={{ __html: introText }} />
      <ButtonNext
        actionButton={actionButton}
        disabled={disabled}
        nextStep={nextStep}
      />
    </div>
  );
}

Intro.propTypes = {
  actionButton: PropTypes.string,
  disabled: PropTypes.bool,
  introText: PropTypes.string,
  nextStep: PropTypes.func,
  title: PropTypes.string,
};

export default Intro;



// WEBPACK FOOTER //
// js/src/assessment/Intro.js